<template>
  <div class="footer">
    <p
      class="disclaimer"
      v-if="disclaimer && disclaimer.show"
      v-html="disclaimer.message"
    />

    <div class="footer--cols">
      <div class="col-1">
        <p>
          <a
            :href="
              isAxnab()
                ? 'https://www.axnab.com/aml/'
                : 'https://banxa.com/legal-compliance/?_ga=2.92118746.1754880715.1655770156-1500146562.1655770156'"
            target="_blank"
            rel="noopener"
          >{{ $t('Footer.label.legalAndCompliance') }}</a
          >
          <a
            v-if="!geoIsUK"
            :href="
              isAxnab()
                ? 'https://support.axnab.com/support/home'
                : 'https://support.banxa.com/?_ga=2.171768416.1754880715.1655770156-1500146562.1655770156'"
            target="_blank"
            rel="noopener"
          > | {{ $t('Footer.label.supportCenter') }}</a
          >
        </p>

        <p>
          <span>{{ $t('Footer.label.authorised') }}</span>
        </p>
      </div>
      <div class="col-2">
        <p>
          {{ $t('Footer.label.relevantEntity1') }}
          <br />
          {{ $t('Footer.label.relevantEntity2') }}
          <a
            :href="getLinkByHost('terms')"
            target="_blank"
            rel="noopener"
          >Terms and Conditions</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useGlobalStore } from '@/stores/globalStore';

import { checkGeo } from '@/composables/helpers/useDetectedGeo';
import useAxnab from '@/composables/identity/useAxnab';

const { t } = useI18n();
const { getLinkByHost, isAxnab } = useAxnab();
const globalStore = useGlobalStore();
const geoIsUK = computed(() => checkGeo('GB'));
const disclaimer = computed(() => {
  // TODO: Add condition for specific merchant
  let geoCheck = false;
  if (globalStore?.getDetectedGeo) {
    geoCheck = globalStore?.getDetectedGeo?.country_code?.toUpperCase() === 'US';
  }
  return {
    show: geoCheck || true,
    message: t('Footer.label.disclaimer'),
  };
});
</script>

<style lang="scss">
.footer {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 0.8rem;

  p,
  span,
  a {
    color: var(--footer-text-color);
    font-size: $font-body-small * 0.75;
  }

  &.disclaimer {
    color: var(--footer-text-color);
    margin-bottom: 2rem;
  }
}
</style>
